import { render, staticRenderFns } from "./ConfirmationSummaryIntro.vue?vue&type=template&id=85881318&scoped=true&"
import script from "./ConfirmationSummaryIntro.vue?vue&type=script&lang=js&"
export * from "./ConfirmationSummaryIntro.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationSummaryIntro.vue?vue&type=style&index=0&id=85881318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85881318",
  null
  
)

export default component.exports